import { Routes, Route } from 'react-router-dom';
import RequireAdmin from '@/components/RequireAdmin';
import RequireKiosk from '@/components/RequireKiosk';
import AppShell from '@/components/AppShell';
import StagingBanner from '@/components/StagingBanner';
import SignInPage from '@/pages/SignInPage';
import DashboardPage from '@/pages/DashboardPage';
import UsersPage from '@/pages/UsersPage';
import ExhibitorsPage from '@/pages/ExhibitorsPage';
import ExhibitorDetailPage from '@/pages/ExhibitorDetailPage';
import ContentReviewPage from '@/pages/ContentReviewPage';
import AdjacencyGroupsPage from '@/pages/AdjacencyGroupsPage';
import PaymentsPage from '@/pages/PaymentsPage';
import SponsorshipsPage from '@/pages/SponsorshipsPage';
import EmailsPage from '@/pages/EmailsPage';
import BroadcastPage from '@/pages/BroadcastPage';
import SettingsPage from '@/pages/SettingsPage';
import BoothsPage from '@/pages/BoothsPage';
import EmailTemplatesPage from '@/pages/EmailTemplatesPage';
import ApplicationAllowlistPage from '@/pages/ApplicationAllowlistPage';
import KioskPage from '@/pages/KioskPage';
import CheckinsPage from '@/pages/CheckinsPage';

function App() {
  return (
    <>
      <StagingBanner />
      <Routes>
        <Route path="/sign-in" element={<SignInPage />} />
        {/* 当日の受付端末。管理画面の枠 (サイドバー) を出さず全画面で使う */}
        <Route
          path="/kiosk"
          element={
            <RequireKiosk>
              <KioskPage />
            </RequireKiosk>
          }
        />
        <Route
          path="/*"
          element={
            <RequireAdmin>
              <AppShell>
                <Routes>
                  <Route path="/" element={<DashboardPage />} />
                  <Route path="/users" element={<UsersPage />} />
                  <Route path="/exhibitors" element={<ExhibitorsPage />} />
                  <Route path="/exhibitors/:id" element={<ExhibitorDetailPage />} />
                  <Route path="/content-review" element={<ContentReviewPage />} />
                  <Route path="/adjacency-groups" element={<AdjacencyGroupsPage />} />
                  <Route path="/emails" element={<EmailsPage />} />
                  <Route path="/broadcast" element={<BroadcastPage />} />
                  <Route path="/email-templates" element={<EmailTemplatesPage />} />
                  <Route path="/payments" element={<PaymentsPage />} />
                  <Route path="/sponsorships" element={<SponsorshipsPage />} />
                  <Route path="/booths" element={<BoothsPage />} />
                  <Route path="/checkins" element={<CheckinsPage />} />
                  <Route path="/application-allowlist" element={<ApplicationAllowlistPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                </Routes>
              </AppShell>
            </RequireAdmin>
          }
        />
      </Routes>
    </>
  );
}

export default App;
